import React/*, {useState}*/ from 'react';
import {useracc, postApi, putApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';

import Button from 'react-bootstrap/Button';
import ToggleButton from 'react-bootstrap/ToggleButton';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import ListGroup from 'react-bootstrap/ListGroup';

class RSS extends React.Component {
	static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			loaded: false,
      /*code1: '',
			code2: '',*/
			season: '',
			seasons: [],
			tmdb: '',
			tmdbs: [],
			tvshow: '1',
    };
		this.handleChange = this.handleChange.bind(this);
		this.searchSeasons = this.searchSeasons.bind(this);
		this.submitSeasons = this.submitSeasons.bind(this);
		this.searchTmdb = this.searchTmdb.bind(this);
		this.submitTmdb = this.submitTmdb.bind(this);
  };

	async componentDidMount() {
		const value = this.context;
		const getUser = await useracc();
    value.setUser( getUser );
   	this.setState({ loaded: true});
  }

	async handleChange(event) {
		switch( event.target.name ) {
			case 'torrent':
				this.setState({torrent: event.target.value});
			break;
			case 'tmdb':
				this.setState({tmdb: event.target.value});
			break;
			case 'season':
				//console.log(event);
				let seasons = this.state.seasons;
				for( let i in seasons ) {
					if( seasons[i].imdbtt === event.imdbtt ) {
						seasons[i].season = event.target.value;
					}
				}
				this.setState({seasons});
			break;
			case 'season_name':
				//console.log(event);
				let _seasons = this.state.seasons;
				for( let i in _seasons ) {
					if( _seasons[i].imdbtt === event.imdbtt ) {
						_seasons[i].season_name = event.target.value===''?null:event.target.value;
					}
				}
				this.setState({seasons: _seasons});
			break;
			case 'boxset':
				let __seasons = this.state.seasons;
				for( let i in __seasons ) {
					if( __seasons[i].imdbtt === event.imdbtt ) {
						__seasons[i].boxset = parseInt(event.target.value);
					}
				}
				this.setState({seasons: __seasons});
			break;
			case 'tvshow':
				this.setState({tvshow: event.target.value});
			break;
		}
	}

	async searchSeasons(event) {
		event.preventDefault();
		const params = new URLSearchParams();
		params.append('torrent', this.state.torrent );
    let x = await postApi('/api/v1/season', params);
		this.setState({seasons: x.data, tmdbs: []});
		//console.log(x.data);
	}

	async submitSeasons(event, imdbtt) {
		event.preventDefault();
		const params = new URLSearchParams();
		params.append('imdbtt', imdbtt );
		for( let i in this.state.seasons ) {
			if( this.state.seasons[i].imdbtt === imdbtt ) {
				params.append('season', this.state.seasons[i].season );
				params.append('season_name', this.state.seasons[i].season_name );
				params.append('boxset', this.state.seasons[i].boxset );
			}
		}
    await putApi('/api/v1/season', params);
	}

	async searchTmdb(event) {
		event.preventDefault();
		const params = new URLSearchParams();
		params.append('tmdb', this.state.tmdb );
		params.append('tvshow', this.state.tvshow );
    let x = await postApi('/api/v1/tmdb', params);
		console.log(x.data);
		this.setState({seasons: [], tmdbs: x.data});
	}

	async submitTmdb(tmdb, tvshow) {
		const params = new URLSearchParams();
		params.append('tmdb', tmdb );
		params.append('tvshow', tvshow);
		await putApi('/api/v1/tmdb', params);
	}

	render() {

		const seasons = this.state.seasons.map((e,i) => {
			return (
				<ListGroup.Item key={i}>
					<div className="row">
						<div className="col-12 col-md-5">
							{e.Title} ({e.Year} - {e.tvshow===0?'Movie':'TV Show'})
						</div>
						<div className="col-12 col-md-5">
							<Form noValidate  onSubmit={(f)=>this.submitSeasons(f, e.imdbtt)}>
								<InputGroup className="">
									<FormControl disabled={e.tvshow===0?true:false} type="number" name="season" id="season" value={e.season} onChange={(f)=>this.handleChange({imdbtt: e.imdbtt, target: {name: 'season', value: f.target.value}})} placeholder="" maxLength="3" />
									<FormControl disabled={e.tvshow===0?true:false} name="name" id="name" value={e.season_name} onChange={(f)=>this.handleChange({imdbtt: e.imdbtt, target: {name: 'season_name', value: f.target.value}})} placeholder="" />
									<ToggleButton
										className=""
										id={e.imdbtt}
										type="checkbox"
										variant="outline-primary"
										checked={e.boxset===1?true:false}
										value="1"
										onChange={(f)=>this.handleChange({imdbtt: e.imdbtt, target: {name: 'boxset', value: 1-e.boxset}})}
										disabled={e.tvshow===0?true:false}
									>
										Boxset
									</ToggleButton>
									<Button disabled={e.tvshow===0?true:false} variant="outline-secondary" id="button-addon2" type="submit" onClick={(f)=>this.submitSeasons(f, e.imdbtt)}>
										>>
									</Button>
								</InputGroup>
							</Form>
						</div>
					</div>
				</ListGroup.Item>
			)
		})

		const tmdbs = this.state.tmdbs.map((e,i) => {
			return (
				<ListGroup.Item key={i}>
					<div className="row">
						<div style={{width: 150}}>
							<img src={e.poster_path} width={130} />
						</div>
						<div className="col-12 col-md-8">
							<div className="row" style={{borderBottom: '1px solid #00000066'}}>
								<div className="col-12 col-md-5">
									{e.name?e.name:e.title} {e.origin_country?<>({e.origin_country.join(',')} {e.year})</>:<>({e.year})</>}
								</div>
							</div>
							<div className="row">
								<div className="col-12 col-md">
									{e.overview}<br /><br />
									<Button size="sm" onClick={()=>this.submitTmdb(e.id, e.tvshow)}>
										Add
									</Button>
								</div>
							</div>
						</div>
					</div>

				</ListGroup.Item>
			)
		})

		return (
			<>
        {this.state.loaded===true &&
					<div className="container-fluid">
						<div className="row">
							<div className="col-12">
								<div className="row">
									<div className="col-12 col-md-3">
										<Form noValidate  onSubmit={this.searchSeasons}>
											<InputGroup className="mb-3">
												<FormControl name="torrent" id="torrent" value={this.state.torrent} onChange={this.handleChange} placeholder="Search Torrents" />
                        <Button variant="outline-secondary" id="button-addon2" type="submit">
                          Search
                        </Button>
											</InputGroup>
										</Form>
									</div>
									<div className="col-12 col-md-4">
										<Form noValidate onSubmit={this.searchTmdb}>
											<InputGroup className="mb-3">
												<FormControl name="tmdb" id="tmdb" value={this.state.tmdb} onChange={this.handleChange} placeholder="Search TMDB" />
												<Form.Select aria-label="Default select example" id="tvshow" name="tvshow" value={this.state.tvshow} onChange={this.handleChange}>
													<option value="1">TV Show</option>
													<option value="0">Movie</option>
												</Form.Select>
                        <Button variant="outline-secondary" id="button-addon2" type="submit">Search</Button>
											</InputGroup>
										</Form>
									</div>
								</div>
							<div>
								<div className="row">
									<div className="col-12">
										<ListGroup variant="flush">
											{this.state.seasons.length > 0 &&
												<ListGroup.Item key={0}>
													<div className="row">
														<div className="col-5 col-md-5">
															Season
														</div>
														<div className="col-7 col-md-6">
															Number / Name / Boxset
														</div>
													</div>
												</ListGroup.Item>
											}
											{seasons}
										</ListGroup>
									</div>
									<div className="col-12">
										<ListGroup variant="flush">
											{this.state.tmdbs.length > 0 &&
												<ListGroup.Item key={0}>
													{/*<div className="row">
														<div className="col-5">
															Season
														</div>
														<div className="col-3">
															Number / Season Name
														</div>
													</div>*/}
												</ListGroup.Item>
											}
											{tmdbs}
										</ListGroup>
									</div>
								</div>
							</div>
								
								
							</div>
						</div>
					</div>
				}
			</>
		)
	}
};

export default RSS;